const ReportTemplateReformatData = (listData, page, take) => {
  const resultList = [];
  const groupMap = {};
  const groupNames = [];

  for (let i = 0; i < listData.length; i++) {
    const el = listData[i];

    const namaJenisMinyak =
      el.data_jenis_minyak && el.data_jenis_minyak.nama
        ? el.data_jenis_minyak.nama
        : "-";

    resultList.push({
      ...el,
      mykey: i + 1,
      no: (page - 1) * take + i + 1,
      jenis_minyak: namaJenisMinyak,
      report_type: "detail",
    });
  }

  return { list: resultList, groupNames, groupMap };
};

export default ReportTemplateReformatData;
